import type { TFunction } from 'i18next';
import type {
  DiscussionError,
  DiscussionForum,
  DiscussionRequest,
  ProposalDiscussion,
} from '../../api/workEnvironmentTypes';
import { fullDate } from '../HRDashboard/hmsFormat';
import type { FieldError } from './assessmentView';
import { today } from './dataSourcesView';

export const DISCUSSION_FORUMS: DiscussionForum[] = ['TEAM_MEETING', 'AMU', 'OTHER'];

export const newDiscussion = (now = new Date()): DiscussionRequest => ({ forum: '', date: today(now), note: '' });

/**
 * The same rules as the API, so the team leader sees the errors at once. Another forum needs a
 * note that says which, and a meeting cannot be in the future.
 */
export const discussionErrors = (discussion: DiscussionRequest, now = new Date()): DiscussionError[] => {
  const checks: Array<[DiscussionError, boolean]> = [
    ['forum', discussion.forum !== ''],
    ['date', /^\d{4}-\d{2}-\d{2}$/.test(discussion.date) && discussion.date <= today(now)],
    ['note', discussion.forum !== 'OTHER' || discussion.note.trim() !== ''],
  ];
  return checks.filter(([, valid]) => !valid).map(([error]) => error);
};

export const DISCUSSION_FIELDS: Record<DiscussionError, string> = {
  forum: 'discussion-forum-TEAM_MEETING',
  date: 'discussion-date',
  note: 'discussion-note',
};

export const discussionFieldErrors = (errors: DiscussionError[], t: TFunction): FieldError[] =>
  errors.map((error) => ({
    fieldId: DISCUSSION_FIELDS[error],
    message: t(`workEnvironmentMeasures.discussions.errors.${error}`),
  }));

/** «Teammøte 8. oktober 2026» */
export const discussionLabel = (
  discussion: Pick<ProposalDiscussion, 'forum' | 'date'>,
  t: TFunction,
  language: string,
) => `${t(`workEnvironmentMeasures.discussions.forums.${discussion.forum}`)} ${fullDate(discussion.date, language)}`;
